import { Card, Skeleton } from "antd";

export default function ExpanseUserInfoSkeleton() {
  return (
    <Card bordered={false} style={{ maxWidth: 600 }}>
      <div className="flex items-center gap-6">
        <Skeleton.Input style={{ width: 50, height: 110 }} active />
        <div className="flex-1 flex flex-col gap-1">
          <Skeleton
            active
            paragraph={{ rows: 3, width: ["50%", "30%", "50%", "60%"] }}
            title={undefined}
          />
        </div>
      </div>
    </Card>
  );
}
